export default function getData(pageSchemaData) {
  if (pageSchemaData === void 0) {
    pageSchemaData = {};
  }
  const {
    url,
    legalName,
    foundingDate,
    logo,
    facebook,
    twitter,
    youTube,
    instagram,
    pinterest,
    linkedin,
    wikipedia,
    telephone
  } = pageSchemaData;
  return {
    '@context': 'http://schema.org/',
    '@type': 'Organization',
    url,
    legalName,
    foundingDate,
    logo,
    sameAs: [facebook, twitter, youTube, instagram, pinterest, linkedin, wikipedia],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      telephone
    }
  };
}